/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions } from './FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions,
    FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18n
 * Переопределения локализации для конкретной платформы
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18n = FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions;

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18nFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18n {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18nFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18nFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18n {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18nToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18nToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18nToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsAdapterConfigI18n | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptionsToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsAdapterI18nOptions);
    }

    return {};
}

